const getConfigByType = {
  app: {
    getNextItem: 'getMenuInfo',
    nextType: ['menu'],
    submitMethod: '',
    clearType: ['menu', 'col', 'row', 'component', 'department']
  },
  systemRow: {
    submitMethod: 'submitSystemRow'
  },
  menu: {
    getNextItem: 'getOtherPermission',
    nextType: ['row', 'col', 'component'],
    submitMethod: 'submitMenu',
    clearType: ['col', 'row', 'component', 'department']
  },
  col: {
    submitMethod: 'submitOthers',
    submitKey: 'dataColRuleAuths',
    submitUrl: '/v1/role/editDataColRule'
  },
  row: {
    submitMethod: 'submitOthers',
    submitKey: 'dataRowRuleAuths',
    submitUrl: '/v1/role/editDataRowRule',
    clearType: []
  },
  component: {
    submitMethod: 'submitOthers',
    submitKey: 'pageComponentAuths',
    submitUrl: '/v1/role/editPageComponent'
  }
};
export { getConfigByType };
